import SocialContractSampleModal from './social-contract-sample-modal';

export default SocialContractSampleModal;